<script>
export default {
    name: "ErrorAlert",
    props:['message','error']
}
</script>

<template>
    <div>
        <transition name="shake">
            <p v-if="message && error"
               :class="['alert text-center mb-0 rounded mt-3 mb-3 px-3 alert-danger']">
                {{ message }}
            </p>
        </transition>
        <transition name="slide-left">
            <p v-if="message && !error"
               :class="['alert text-center mb-0 rounded mt-3 mb-3 px-3 alert-success']">
                {{ message }}
            </p>
        </transition>
    </div>
</template>

<style scoped>

</style>
